import Cookies from 'js-cookie'
const TOKEN_KEY = 'auth_token'
export function getToken() {
  return Cookies.get(TOKEN_KEY)
}
